import {Directive, TemplateRef} from '@angular/core';

@Directive({selector: '[appTabContent]'})
export class TabContentDirective {
    public constructor(public template: TemplateRef<any>) {}
}
